import { useState, useEffect } from 'react';
import { AgGridReact } from 'ag-grid-react';

import { getAllGlossaryTerms } from '../../api/glossary';
import { excelStyles } from '../../components/Grid/ExcelStyles/excelStyles';
import LoadRowsComponent from '../../helpers/LoadRowsComponent';
import TotalRow from '../../components/Grid/CellRenderer/TotalRow';

import './Glossary.scss';

const GlossaryGrid = ({
  search,
  onRowClicked,
  onDeleteClicked,
  setRefresh,
  refresh,
  sort = "",
  setSort = () => {},
}) => {
  const [gridApi, setGridApi] = useState(null);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    if (refresh) {
      let refreshOptions = {};
      if (gridApi.getDisplayedRowCount() === 0) refreshOptions = { purge: true };
      gridApi.refreshServerSideStore(refreshOptions);
      setRefresh(false);
    }
  }, [refresh]);

  useEffect(() => {
    if (gridApi) {
      const dataSource = {
        getRows: function(params) {
          let sortParam = "";
          if (params.request.sortModel.length !== 0) {
            const sortColumn = params.request.sortModel[0].colId;
            const sortWay = params.request.sortModel[0].sort;
            if (sortWay === "desc") {
              sortParam += "-";
            }
            sortParam += sortColumn;
            sortParam = sortParam.replaceAll(".", "__");
          }
          if (sortParam) {
            setSort(sortParam);
          } else {
            setSort("");
          }
          getAllGlossaryTerms({ limit: 100, offset: params?.request.startRow, search: search, sort: sort })
            .then(res => {
              const items = res.results?.map(item => ({
                ...item,
              }));
              setTotalRows(res.count);
              params.success({
                rowData: items,
                rowCount: res.count,
              });
              if (res.count === 0) {
                gridApi.showNoRowsOverlay();
              }
            });
        }
      };
      gridApi.setServerSideDatasource(dataSource);
    }
  }, [gridApi, search, sort]);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const cellClicked = (event) => {
    const { cellRenderer } = event.colDef;
    if (cellRenderer !== "removeRow") {
      onRowClicked(event.data);
    }
  };

  const deleteRow = (itemId, itemName) => {
    onDeleteClicked(itemId, itemName);
  };

  const gridOptions = {
    columnDefs: [
      {
        headerName: 'Term',
        field: 'term',
        flex: '1',
      },
      {
        headerName: 'Definition',
        field: 'definition',
        flex: '2',
      },
      {
        headerName: 'Supporting Information',
        field: 'supporting_information',
        cellRenderer: "emDashEmpty",
        flex: '2',
      },
      {
        headerName: "",
        width: 40,
        cellRenderer: "removeRow",
      }
    ],
    defaultColDef: {
      resizable: true,
      sortable: true,
      wrapText: true,
      filter: true,
      enablePivot: true,
      enableCharts: false,
      enableRowGroup: true,
      filterParams: {
        clearButton: true
      },
      cellStyle: { "white-space": "normal !important" },
      autoHeight: true,
      cellClassRules: {
        oddBackground: function (params) {
          return params.rowIndex % 2 == 0;
        },
      },
    },
    excelStyles,
    frameworkComponents: {
      emDashEmpty: ({ value }) => {
        return <span>{value || "\u2014"}</span>;
      },
      removeRow: ({ data }) => {
        const id = data?.id;
        const name = data?.term;
        return (
          <i
            className="fal fa-trash-alt"
            style={{ color: "red" }}
            onClick={() => deleteRow(id, name)}
          ></i>
        );
      },
      LoadRowsComponent: LoadRowsComponent,
    },
    loadingCellRenderer: 'LoadRowsComponent',
    loadingCellRendererParams: {
      loadingMessage: 'One moment please...',
    },
  };

  return (
    <div className="ag-theme-balham" style={{ width: '100%', height: '100%', paddingBottom: '20px' }}>
      <AgGridReact
        onGridReady={onGridReady}
        gridOptions={gridOptions}
        onCellClicked={event => cellClicked(event)}
        rowModelType={'serverSide'}
        serverSideStoreType={'partial'}
        cacheBlockSize={100}
      ></AgGridReact>
      <TotalRow count={totalRows} />
    </div>
  );
};

export default GlossaryGrid;
